import { render, staticRenderFns } from "./creaPdfPazySalvoV2.vue?vue&type=template&id=ed0b21d8&scoped=true"
import script from "./creaPdfPazySalvoV2.vue?vue&type=script&lang=js"
export * from "./creaPdfPazySalvoV2.vue?vue&type=script&lang=js"
import style0 from "./creaPdfPazySalvoV2.vue?vue&type=style&index=0&id=ed0b21d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b21d8",
  null
  
)

export default component.exports